module.exports = __webpack_public_path__ + "img/square_2.dc206a59.png";